import VAPUsersTable from './VAPUsersTable';
export default VAPUsersTable;